export default function Apply({ completePopupHanlder }) {
  return (
    <div className="bg">
      <div className="bg_wrap">
        <div className="close">
          <img
            src="/worldcup/imgs/close.png"
            alt="닫기"
            onClick={() => {
              completePopupHanlder(false);
            }}
          />
        </div>
        <h3>응모 완료!!</h3>

        <p>당첨자 발표일 : 12월 7일 (목) 개별 통보</p>

        <ul>
          <li>
            <span></span>상품 추첨 후 입력하신 연락처로 개별연락을 드립니다.
          </li>
          <li>
            <span></span>
            문자발송 후 7일간 연락이 되지 않을 시 당첨은 취소 됩니다.
          </li>
          <li>
            <span></span>
            상품 배송의 경우 잘못된 정보를 기재하여 발생하는 문제에 대해서는
            책임을 지지 않습니다.
          </li>
          <li>
            <span></span>
            5만원 초과 사은품의 제세공과금 22%가 발생하나 모두 주최측인
            “에이블모멘트"에서 부담합니다.
          </li>
          <li>
            <span></span>
            이벤트 경품, 기간, 경품발송일 등 내용은 주최측 사정에 따라 사전 예고
            없이 변경될 수 있습니다.
          </li>
          <li>
            <span></span>
            이벤트 경품 내역은 양도 및 양수가 되지 않으며, 타 상품으로 교환 및
            환불이 불가능합니다
          </li>
        </ul>
        <button
          type="submit"
          className="apply_btn"
          onClick={() => {
            completePopupHanlder(false);
          }}
        >
          확인
        </button>
      </div>
    </div>
  );
}
